import axios from "axios";
import {apiUrlInternal} from "../../config/api";
import {useQueryWithAuthentication} from "../index";
import PropTypes from "prop-types";
import {addAuthToAxiosOpts} from "../../config/queryopts";


export const DarkSearchFetcher = (query, accessToken, query_type = null) => {
  const urlParams = new URLSearchParams();
  if (query_type) {
    urlParams.set('query_type', query_type);
  }
  urlParams.set('query', query);

  return axios.get(
    `${apiUrlInternal}/darksearch?${urlParams.toString()}`,
    addAuthToAxiosOpts(accessToken, {}, 60000)
  ).then(res => res.data);
}

export const useDarkSearchQuery = (query = null, query_type = null, fetcher = DarkSearchFetcher) => {
  return useQueryWithAuthentication(
    ['dark-search', query], (accessToken) => fetcher(query, accessToken, query_type),
    {staleTime: Infinity, enabled: !!query, retry: false, refetchOnWindowFocus: false}
  )
}

useDarkSearchQuery.propTypes = {
  query: PropTypes.string.isRequired,
}
